import Header from './Header';
import Sider from './Sider';
import SmartSider from './SmartSider';
import Content from './Content';
import PageLayoutIn from './PageLayout';
const PageLayout = PageLayoutIn;
PageLayout.Header = Header;
PageLayout.Sider = Sider;
PageLayout.Content = Content;
PageLayout.SmartSider = SmartSider;
export default PageLayout;
export { siderWidth } from './Sider';
//# sourceMappingURL=es/index.js.map